// Wait until the page is fully loaded
$(document).ready(function() {

  // Handle tab switching
  $(document).on('click', '.tab-link', function () {
    var tab_id = $(this).attr('data-tab');
    $('ul.tabs li').removeClass('active');
    $('.tab-content').removeClass('active');

    $(this).addClass('active');
    $('#tab-' + tab_id).addClass('active');
  });

  // Smooth scroll to a section on page load if there's a #hash in the URL
  if (window.location.hash) {
    var target = $('#' + window.location.hash.substr(1));
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - 150
      }, 800); // Faster scroll (was 2000ms)
    }
  }

  // Add "Read More / Read Less" toggle
  var characterLength = 400;
  var readMoreTxt = "...Read more";
  var readLessTxt = "Read less";

  $(".add-read-more").each(function() {
    var content = $(this).text();

    if (content.length > characterLength) {
      var firstPart = content.substring(0, characterLength);
      var secondPart = content.substring(characterLength);

      var html = firstPart + 
        "<span class='SecSec' style='display:none;'>" + secondPart + "</span>" +
        "<span class='read-more' style='color:blue; cursor:pointer;'> " + readMoreTxt + "</span>" +
        "<span class='read-less' style='color:blue; cursor:pointer; display:none;'> " + readLessTxt + "</span>";

      $(this).html(html);
    }
  });

  // Toggle read more / read less
  $(document).on('click', '.read-more', function () {
    $(this).siblings('.SecSec').show();
    $(this).hide();
    $(this).siblings('.read-less').show();
  });

  $(document).on('click', '.read-less', function () {
    $(this).siblings('.SecSec').hide();
    $(this).hide();
    $(this).siblings('.read-more').show();
  });

});
